export default __webpack_public_path__ + "static/media/google-upload-2-tw.98881bfd.jpeg";